//转换函数--13个
export const TranslateFunc = [
  {
    "key": "ToStringX",
    "name": "ToStringX",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value to a string \n[Return value type]: String (String)\n [Example]: ToStringX(123) [Return value]: "123"`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDateTime",
    "name": "ToDateTime",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value to date and time \n[Return value type]: Date and time (OffsetDateTime)\n [Example]: ToDateTime("2019-01-30T10:00:00+08:00") [Return Value]: 2019-01-30T10:00+08:00`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToBoolean",
    "name": "ToBoolean",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into an equivalent Boolean value \n[Return value type]: Boolean value (Boolean)\n [Example]: ToBoolean("True") [Return value]: true`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDecimal",
    "name": "ToDecimal"
  },
  {
    "key": "ToBigDecimal",
    "name": "ToBigDecimal",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into a decimal value \n[Return value type]: Decimal value (BigDecimal)\n [Example]: ToBigDecimal("40.23") [Return value]: 40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToCustomBigDecimal",
    "name": "ToCustomBigDecimal",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      },
      {
        "key": "number",
        "name": "number",
        "type": "int"
      }
    ],
    "description": `[Function]: Convert the converted value into a decimal value with the specified precision \n[Return value type]: Decimal value (BigDecimal)\n [Example]: ToCustomBigDecimal("40.2,2") [Return value]: 40.20`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDouble",
    "name": "ToDouble",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into a double-precision floating-point number \n[Return value type]: Double-precision floating-point number (Double)\n [Example]: ToDouble("40.23") [Return value]: 40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToSingle",
    "name": "ToSingle"
  },
  {
    "key": "ToFloat",
    "name": "ToFloat",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into a single-precision floating-point number \n[Return value type]: Single-precision floating-point number (Float)\n [Example]: ToFloat("40.23") [Return value]: 40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToByte",
    "name": "ToByte",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into 8-bit unsigned integer \n[Return value type]: 8-bit unsigned integer (Byte)\n [Example]: ToByte("10") [Return value]: 10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt16",
    "name": "ToInt16",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into a 16-bit signed integer \n[Return value type]: 16-bit signed integer (Int16)\n [Example]: ToInt16("10") [Return value]: 10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt32",
    "name": "ToInt32",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value into a 32-bit signed integer \n[Return value type]: 32-bit signed integer (Int32)\n [Example]: ToInt32("10") [Return value]: 10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToChineseMoney",
    "name": "ToChineseMoney",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Convert the converted value to Chinese uppercase amount \n[Return value type]: String (String)\n [Example]: ToChineseMoney(40.23) [Return value]: "四十元零二角三分 "`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]